import React, { FC } from 'react';
import { graphql, createFragmentContainer, Environment } from 'react-relay';

// types
import { BuyerChatLazy_viewer as Viewer } from './__generated__/BuyerChatLazy_viewer.graphql';

const LazyComponent = React.lazy(() => import(/* webpackChunkName: "BuyerChat" */ './BuyerChat'));

type Props = {
    viewer: Viewer;
    environment: Environment;
    isInitiallyMinimized: boolean;
};

export const BuyerChatLazyComponent: FC<Props> = props =>
    props.viewer ? (
        <React.Suspense fallback="">
            <LazyComponent {...props} />
        </React.Suspense>
    ) : null;

export const BuyerChatLazy = createFragmentContainer(BuyerChatLazyComponent, {
    viewer: graphql`
        fragment BuyerChatLazy_viewer on Viewer {
            ...BuyerChat_viewer
        }
    `,
});
